// extracted by mini-css-extract-plugin
export default {"component":"UE9Ugs","heading":"c15oLf","headingMobile":"uS0BAq"};